<template>
  <el-table-column
    prop="phone"
    sortable
    label="Telefonszám"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.phone }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'phone',
  };
</script>
